module.exports = __webpack_public_path__ + "img/google.8caebf24.png";